import { includes, map, upperFirst } from 'lodash/fp';
import constants from '@ahmdigital/constants';

import { FIELD_NAMES, INCOME_TIER_NONE, SCALES_WITH_MULTIPLE_ADULTS } from '../../components/pricing-drawer/constants';
import getDateOfBirthFromAge from '../get-date-of-birth-from-age';
import uncapFpIterator from '../../../utils/uncap-fp-iterator';
import type { FieldNames, PricingDrawerActions } from '../../components/pricing-drawer/types';
import type { RefinePriceActions } from '../../pages/refine-price/types';

const { AGE, HOSPITAL_EXCESS, INCOME_TIER, PARTNER_AGE } = FIELD_NAMES;
const { RELATIONSHIP } = constants;

const mapWithIndex = uncapFpIterator(map);
const furtherConditionList: Array<string> = [AGE, INCOME_TIER, PARTNER_AGE];

type Params = {
  actions: PricingDrawerActions | RefinePriceActions;
  rebate: Boolean;
  updatedFields: {
    [key in FieldNames]?: any;
  };
  scale: string;
};

const submitUpdatedRefineFields = ({ actions, rebate, updatedFields, scale }: Params) => {
  const scaleForPartnerAge = updatedFields?.scale || scale;
  mapWithIndex((value: string, key: string) => {
    if (!includes(key, furtherConditionList)) {
      // @ts-expect-error - Automatic, Please fix when editing this file
      actions.customer[`change${upperFirst(key)}`](value);
    }
    if (key === AGE) {
      const clientDateOfBirth = getDateOfBirthFromAge(value);
      actions.customer.changeDateOfBirth(clientDateOfBirth, RELATIONSHIP.CLIENT);
    }
    if (key === HOSPITAL_EXCESS) {
      actions.customer.changeHospitalExcess(value);
    }
    if (key === INCOME_TIER && value !== INCOME_TIER_NONE) {
      actions.customer.changeRebate(true);
      actions.customer.changeIncomeTier(value);
    }
    if (key === INCOME_TIER && rebate === true && value === INCOME_TIER_NONE) {
      actions.customer.changeRebate(false);
    }
    if (key === PARTNER_AGE && includes(scaleForPartnerAge, SCALES_WITH_MULTIPLE_ADULTS)) {
      const spouseDateOfBirth = getDateOfBirthFromAge(value);
      actions.customer.changeDateOfBirth(spouseDateOfBirth, RELATIONSHIP.SPOUSE);
    }
  }, updatedFields);
  return null;
};

export default submitUpdatedRefineFields;
